import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!

  return (_openBlock(), _createBlock(_component_Multiselect, {
    class: _normalizeClass({'multiselect-sm': _ctx.small}),
    modelValue: _ctx.vModel,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.vModel) = $event)),
    disabled: _ctx.disabled,
    options: _ctx.groups,
    "custom-label": _ctx.formatLabel,
    "track-by": "id",
    "select-label": "",
    "deselect-label": "",
    placeholder: _ctx.placeholder ?? _ctx.helper.trans('notification_center.merchant_tg_groups_placeholder'),
    "open-direction": "bottom",
    multiple: true,
    searchable: true,
    loading: _ctx.isLoading,
    "internal-search": false,
    "clear-on-select": false,
    "close-on-select": false,
    "options-limit": 50,
    limit: 50,
    "show-no-results": true,
    "hide-selected": true,
    onSearchChange: _ctx.asyncFind
  }, null, 8, ["class", "modelValue", "disabled", "options", "custom-label", "placeholder", "loading", "onSearchChange"]))
}